import React, { Component } from 'react'
import Slider from "react-slick"
import img1 from '../assets/img/DSC_6191-min.JPG'
import img2 from '../assets/img/DSC_5982-min.JPG'
import img3 from '../assets/img/DSC_6122-min.JPG'
import img4 from '../assets/img/DSC_6235-min.JPG'
import img5 from '../assets/img/DSC_6382-min.JPG'
import img6 from '../assets/img/DSC_5942-min.JPG'
import img7 from '../assets/img/6036-min.jpg'
import img8 from '../assets/img/DSC_6112-min.JPG'
import img9 from '../assets/img/DSC_6310-min.JPG'
import './css/Gallery.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default function Gallery(){

    return(
        <section id="gallery">
            <div className="row mb-2" data-aos="zoom-in" data-aos-delay="100">
                <div className="col-md-12 text-center">
                    <h1 className="section-title-dark">Us</h1>
                <br/>
                </div>
            </div>
            <div className="row" data-aos="zoom-in" data-aos-delay="100">
                <div className="col-12">
                    <Slider className="baguetter" {...settings}>
                        <a value={img1}>
                            <img className="gallery-img" src={img1} alt={img1} />
                        </a>
                        <a value={img2}>
                            <img className="gallery-img" src={img2} alt={img2} />
                        </a>
                        <a value={img3}>
                            <img className="gallery-img" src={img3} alt={img3} />
                        </a>
                        <a value={img4}>
                            <img className="gallery-img" src={img4} alt={img4} />
                        </a>
                        <a value={img5}>
                            <img className="gallery-img" src={img5} alt={img5} />
                        </a>
                        <a value={img6}>
                            <img className="gallery-img" src={img6} alt={img6} />
                        </a>
                        <a value={img7}>
                            <img className="gallery-img" src={img7} alt={img7} />
                        </a>
                        <a value={img8}>
                            <img className="gallery-img" src={img8} alt={img8} />
                        </a>
                        <a value={img9}>
                            <img className="gallery-img" src={img9} alt={img9} />
                        </a>
                    </Slider>
                </div>
            </div>
        </section>
    )
}

var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    responsive: [{
        breakpoint: 600,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 400,
        settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    },
        {
        breakpoint: 900,
        settings: {
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1
        }
    },
        {
        breakpoint: 1025,
        settings: {
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1
        }
    }]
};
